import { NextImage, SkeletonBox } from '@apeiron/temp'
import { styled, Typography } from '@mui/material'
import { FC } from 'react'

const Container = styled(SkeletonBox)`
  align-items: center;
  display: flex;
  gap: 5px;
`

const Icon = styled(NextImage)`
  aspect-ratio: 1;
  width: 20px;
`

const Name = styled(Typography)`
  font-size: 14px;
  font-weight: 300;
`

const Value = styled(Name)`
  flex: 1;
  text-align: right;
`

const ApeironStatsLabel: FC<Props> = props => {
  const { className, icon, loading, name, value } = props

  return (
    <Container loading={loading} className={className}>
      <Icon src={icon} />
      <Name>{name}</Name>
      <Value>{value}</Value>
    </Container>
  )
}

type Props = {
  className?: string
  icon: string
  loading?: boolean
  name: string
  value: string | number
}

export default ApeironStatsLabel
